



















































import Vue, { PropType } from 'vue';
import TableFilterItems from '@/components/table/newTable/TableFilterItems.vue';
import TableFilterValues from '@/components/table/newTable/TableFilterValues.vue';
import { getIcon, TIconSvg } from '@/configs/iconsConfigs';
import { getTranslate } from '@/helpers/translateHelpers';
import {
  TSelectedFilterValue,
  TSelectedFilterValues,
  TTableValuesPayload,
} from '@/components/table/types';
import { TTableColumn, TTableColumns } from '@/components/table/types';
import TableService from '@/services/TableService';
import { setColumnMultipleFromFilterMultiple } from '@/helpers/tableHelpers';

//TODO: Сделать компонент FilterColumns(первый блок)
//TODO: Добавить отключение мульти выделение
export default Vue.extend({
  name: 'TableFilter',
  components: { TableFilterItems, TableFilterValues },

  props: {
    columnsData: {
      type: Array as PropType<TTableColumns>,
    },
    name: {
      type: String,
      required: false,
      default: getTranslate('body.topBar.buttons.filters'),
    },
    icon: {
      type: String as PropType<TIconSvg>,
      required: false,
      default: getIcon('filters'),
    },
    title: {
      type: String,
      required: false,
      default: getTranslate('body.topBar.filters.categoryFilter'),
    },
    multiple: {
      type: Boolean,
      required: false,
      default: true,
    },
    firstItemOpen: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  watch: {
    columnsData: {
      handler(newValue: TTableColumns) {
        this.columns = setColumnMultipleFromFilterMultiple(
          newValue,
          this.multiple
        );
      },
      immediate: true,
    },
    selectedValues: {
      handler() {
        this.change();
      },
      immediate: true,
    },
  },

  computed: {
    activeColumns(): TTableColumns {
      return TableService.filterColumnsByUseIsFilter(this.columns);
    },
    activeColumn(): TTableColumn | null {
      return TableService.getColumn(this.columns, 'field', this.selectedColumn);
    },
    selectedValues(): TSelectedFilterValues {
      return TableService.getFilterValues(this.columns);
    },
  },

  methods: {
    selectColumn(field: string) {
      this.selectedColumn = field;
    },
    selectItems(payload: TTableValuesPayload) {
      this.addNewFilterValue(payload);
    },
    removeSelectedValue(selectedValues: TSelectedFilterValue) {
      const payload: TTableValuesPayload = TableService.removeSelectedValue(
        this.columns,
        selectedValues
      );

      this.addNewFilterValue(payload);
    },
    addNewFilterValue(payload: TTableValuesPayload) {
      this.columns = TableService.addNewFilterValueWithMultiple(
        this.columns,
        payload,
        this.multiple
      );

      this.change();
    },
    clearSelectedColumn() {
      if (!this.selectedValues?.length) {
        this.selectedColumn = '';
      }
    },
    setSelectedColumn() {
      if (this.selectedValues?.length) {
        this.selectedColumn = this.selectedValues[0].field;
      } else if (this.firstItemOpen) {
        this.selectedColumn = this.columns[0]?.field ?? '';
      }
    },
    closeModal() {
      this.modal = false;
      this.clearSelectedColumn();
    },
    changeModal() {
      this.modal = !this.modal;
      this.setSelectedColumn();
    },
    change() {
      this.$emit('change', this.selectedValues);
    },
  },

  data() {
    return {
      columns: [] as TTableColumns,
      modal: false,
      selectedColumn: '',
    };
  },
});
